<template>
	<el-dialog
		:visible.sync="dialogVisible"
		:destroy-on-close="true"
		:close-on-click-modal="!creating"
		:close-on-press-escape="!creating"
		:show-close="!creating"
		append-to-body
		width="30%"
		top="15vh">
		<div class="d-flex mb-4">
			<h3 class="mr-auto ml-auto">{{ $t("title") }}</h3>
		</div>
		<div class="name-form">
			<label class="name-label">{{ $t("name") }}</label>
			<el-input
				v-model="name"
				@keyup.native.enter="submit()" />
		</div>
		<div class="d-flex justify-content-center mt-4 button-row">
			<el-button
				:disabled="creating"
				@click="cancel()">
				{{ $t("cancel") }}
			</el-button>
			<el-button
				type="success"
				plain
				:loading="creating"
				:disabled="!name.trim()"
				@click="submit()">
				{{ $t("create") }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { parseTypedEmails } from "@/javascripts/contactEmails.mjs";

export default {
	props: {
		value: Boolean,
		creating: Boolean,
		initialSupplier: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			name: ""
		};
	},
	computed: {
		dialogVisible: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
			}
		}
	},
	watch: {
		value(visible) {
			if (visible) {
				this.name = this.initialSupplier?.name ?? "";
			}
		}
	},
	methods: {
		cancel() {
			this.dialogVisible = false;
		},
		submit() {
			const name = this.name.trim();
			if (!name || this.creating) {
				return;
			}
			// A name made of e-mail addresses ("a@x.com, b@y.com") is also the contact e-mails.
			this.$emit("create", { name, contactEmail: parseTypedEmails(name) });
		}
	}
};
</script>

<style scoped>
.name-form {
	width: 80%;
	margin: 0 auto;
	text-align: left;
}

.name-label {
	display: block;
	margin-bottom: 8px;
	font-size: 14px;
	color: #606266;
}

.button-row {
	gap: 12px;
}
</style>

<i18n>
{
  "en": {
    "title": "Create an intermediary supplier",
    "name": "Name",
    "cancel": "Cancel",
    "create": "Create"
  },
  "fr": {
    "title": "Créer un fournisseur intermédiaire",
    "name": "Nom",
    "cancel": "Annuler",
    "create": "Créer"
  },
  "de": {
    "title": "Vermittler-Anbieter erstellen",
    "name": "Name",
    "cancel": "Abbrechen",
    "create": "Erstellen"
  }
}
</i18n>
